import { SchoolId } from '@openeducation/oe-rn-shared-types';

export type NextuSchoolColorsType = { [key: string]: string };

export const nextuSchoolColors: NextuSchoolColorsType = {
  [SchoolId.MARKETING_DIGITAL]: '#FF8C00',
  [SchoolId.CLOUD_COMPUTING]: '#FFE600',
  [SchoolId.DISENO_DIGITAL]: '#FF193F',
  [SchoolId.NEGOCIOS_DIGITALES]: '#BC33FF',
  [SchoolId.DESARROLLO_WEB]: '#00CCFF',
  [SchoolId.PROGRAMICION_DE_APPS]: '#00F2C2',
  [SchoolId.DESARROLLO_PROFESIONAL]: '#6C33FF',
  [SchoolId.FIU]: '#081E3F',
  [SchoolId.CRIPTOMONEDAS]: '#F0463E',
};
